import useSWRImmutable from "swr/immutable";
import seon from "@seontechnologies/seon-javascript-sdk";

seon.init();

export function useSeonSession(initialSeonSession?: string) {
  return useSWRImmutable("seon-session", () =>
    initialSeonSession
      ? Promise.resolve(initialSeonSession)
      : seon.getSession(),
  );
}
